import moment from "moment";
import React from "react";

function SubmitShowModal({ modalProps }) {
  const { isOpen, setIsOpen, EditConfirm, data, newData } = modalProps;

  const modalStyles = {
    display: isOpen ? "flex" : "none",
    alignItems: "center",
    justifyContent: "center",
    position: "fixed",
    zIndex: 1050,
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.6)",
    padding: "20px",
  };

  const modalContentStyles = {
    backgroundColor: "#fff",
    width: "100%",
    maxWidth: "700px",
    borderRadius: "12px",
    padding: "30px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
    textAlign: "center",
  };

  const headerStyles = {
    marginBottom: "20px",
  };

  const buttonContainer = {
    display: "flex",
    justifyContent: "center",
    marginTop: "30px",
    
  };

  const buttonStyle = {
    padding: "12px 24px",
    borderRadius: "30px",
    fontSize: "16px",
    cursor: "pointer",
    border: "none",
    transition: "background-color 0.3s ease",
  };

  const cancelButtonStyle = {
    ...buttonStyle,
    backgroundColor: "#6c757d",
    color: "#fff",
    marginRight : "20px"
  };

  const confirmButtonStyle = {
    ...buttonStyle,
    backgroundColor: "#28a745",
    color: "#fff",
    marginLeft :"20px"
  };
  const td = {
    width : "100px"
  }

  // Updated style for the row with location details, using flexbox.
  const locationRowStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#f1f1f1",
    padding: "15px",
    borderRadius: "8px",
    margin: "15px 0",
  };

  const locationItemStyle = {
    margin: "0 10px",
    flex: 1,
    textAlign: "center",
  };
  console.log(newData);
  console.log(data,"data");

  return (
    <div style={modalStyles}>
      <div style={modalContentStyles}>
        <div style={headerStyles}>
          <h2 style={{ color: "#cb2734", marginBottom: "10px" }}>
            Vimo Services
          </h2>
          <h5 style={{ fontWeight: "bold" }}>Edit Booking Summary</h5>
        </div>
        <table className="table">
          <tbody>
            {Object.keys(newData).map((key) => {
              console.log(key);
              if(key  == "extra_stops"){
                console.log("called");
                
                return newData[key].map((value, index)=>{

                  if(! newData?.old_stops){
                    return (
                      <tr key={`extra${index}`}>
                        <td><strong>Stop {index+1}:</strong></td>
                        <td> - - -</td>
                        <td>{value.stop_name}</td>
                      </tr>
                    );
                  }
                  
                  if(value.stop_name != newData["old_stops"]?.[index]?.["stop_name"] ){
                    // console.log(value.stop_name,"s");
                    return (
                      <tr key={`old_stops${index}`}>
                        <td><strong>Stop {index+1}:</strong></td>
                        <td><del style={{ color: "#cb2734" }}>{newData["old_stops"]?.[index]?.["stop_name"] ?? "0"}</del></td>
                        <td>{value.stop_name}</td>
                      </tr>
                    );
                    
                  }
                  
                })
              }
              else if(key  == "new_addon"){
                console.log("called new addon");
                
                return newData[key].map((value, index)=>{
                  
                  if(value.count != newData["old_addon"]?.[index]?.["count"] ){
                    console.log(value.count,"count");
                    return (
                      <tr key={`old_addon${index}`}>
                        <td style={td}><strong>{value.addon_name}:</strong></td>
                        <td><del style={{ color: "#cb2734" }}>{newData["old_addon"]?.[index]?.["count"] ?? "0"}</del></td>
                        <td>{value.count}</td>
                      </tr>
                    );
                    
                  }
                  
                })
              }
              else if(key  == "delete_stops"){
                return newData[key].map((value, index)=>{
                  
                    return (
                      <tr key={`delete_stop${index}`}>
                        <td><strong>Delete Stop {index+1}:</strong></td>
                        <td><del style={{ color: "#cb2734" }}>{newData["delete_stops"][index]["stop_name"]}</del></td>
                        <td>  - - -  </td>
                      </tr>
                    );
                    
                  
                  
                })
              }
              else if (key != 'old_stops' &&key != 'old_addon' &&   newData[key] !== data[key]) {
                
                const label = key
                  .split('_')
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(' ');

                  
                return (
                  <tr key={key}>
                    <td><strong>{label}:</strong></td>
                    <td><del style={{ color: "#cb2734" }}>{data[key]}</del></td>
                    <td>{newData[key]}</td>
                  </tr>
                );
              }
              
              return null;
            })}
          </tbody>
        </table>
        <div style={buttonContainer}>
          <button
            className="not_disble_fields"
            type="button"
            style={cancelButtonStyle}
            onClick={() => setIsOpen(false)}
          >
            Cancel
          </button>
          <button
            className="not_disble_fields"
            type="button"
            style={confirmButtonStyle}
            onClick={EditConfirm}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}

export default SubmitShowModal;
